// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
 
 
 
 
 
import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddMerchantPOS from './addMerchantPOS';
import EditMerchantPOS from './updateMerchantPOS';
import MerchantPOSTable from './merchantPOSTable';
import ViewMerchantPOS from './view-merchantPOS';

const MerchantPOS: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasMerchantPOSAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'MerchantPOS')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasMerchantPOSAddAccess ? <AddMerchantPOS /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasMerchantPOSAddAccess ? <EditMerchantPOS/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id`}>
         <ViewMerchantPOS/>
        </Route>

        <Route exact path={`${baseURL}`}>
          <MerchantPOSTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { MerchantPOS };
